import classNames from 'classnames'
import type { FC } from 'react'
import React, { useMemo } from 'react'

import { useListContext } from './list-context'
import type { ListItemIconProps } from './types'
import { FlexInlinePrivate } from '../_primitives/flex/flex-inline'

/**
 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
 */
const ListItemIcon: FC<ListItemIconProps> = React.forwardRef<
  HTMLDivElement,
  ListItemIconProps
>(function ListItemIcon(props, ref) {
  const context = useListContext()
  const { className, color = 'neutral.dark', ...rest } = props
  const __css = useMemo(
    () => ({
      flexShrink: 0,
      minWidth: '56px',
      ...(context.alignItems === 'flex-start' ? { mt: 0 } : {})
    }),
    [context.alignItems]
  )
  return (
    <FlexInlinePrivate
      ref={ref}
      color={color}
      className={classNames(
        {
          'csg-tui-list-item-icon': true
        },
        className
      )}
      __css={__css}
      {...rest}
    />
  )
})

export default ListItemIcon
